import React from "react";
import {useNavigate} from "react-router-dom";
import Button from "../../components/Button/Button";
import "./NotFoundPage.css";

function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <section className="notfound">
      <h1 className="notfound__title">404</h1>
      <p className="notfound__description">Страница не найдена</p>
      <Button buttonName="Назад" additionalClass="notfound__button" onClick={() => navigate(-1)} />
    </section>
  );
}

export default NotFoundPage;
